import flatpickr from "flatpickr"

const Pickr = {
  props: {
    dateFormat: "Y-m-d",
    altFormat: "d/m/Y",
    altInput: true,
  },
  mounted() {
    this.pickr = flatpickr(this.el, this.props)
  },
  updated() {
    // console.log(this.el.dataset)
    this.picker && this.pickr.destroy()
    this.pickr = flatpickr(this.el, this.props)
  },
  destroyed() {
    this.picker && this.pickr.destroy()
  },
}

export default Pickr
